<template>
  <b-container fluid class="background position-relative">
    <img
      src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Tickets_page/tickets.png"
      alt="Stairs and portals leading to other worlds, with a large eye bouncing in the centre."
      class="sr-only"
    />
    <b-img
      src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Tickets_page/portal_twirling.gif"
      class="d-none d-xl-block position-absolute twirl"
      alt=""
      aria-hidden="true"
    />
    <b-img
      src="https://res.cloudinary.com/oredev/image/upload/v1742800149/2025/Tickets_page/eyeball.gif"
      class="d-none d-lg-block position-absolute bouncing-eye"
      alt=""
      aria-hidden="true"
    />
    <b-row class="position-relative">
      <b-col class="p-0">
        <!-- Mobile top img -->
        <b-img
          src="https://res.cloudinary.com/oredev/image/upload/v1742806341/2025/Tickets_page/Tickets_page_mobile.png"
          fluid-grow
          class="d-lg-none"
          style="margin-top: -2px"
          alt="Stairs and portals leading to other worlds, with a large eye bouncing in the centre."
        />
        <b-img
          src="https://res.cloudinary.com/oredev/image/upload/v1742800149/2025/Tickets_page/eyeball.gif"
          class="d-lg-none position-absolute"
          style="width: 40vw; right: 25vw; top: 48vw"
          alt=""
          aria-hidden="true"
        />
      </b-col>
    </b-row>
    <b-row class="pt-4 pb-5 mt-lg-5 pt-lg-5">
      <b-col cols="12" lg="5" class="ml-lg-5">
        <b-row>
          <b-col>
            <h1 class="bright-yellow">ØREDEV DEVELOPERS CONFERENCE</h1>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h1 class="light-pink">5-7TH NOV 2025</h1>
          </b-col>
        </b-row>
        <b-container fluid id="buy" class="bg-beige py-3 mb-5">
          <b-row>
            <b-col class="px-xl-5">
              <p class="text-right prices-info-paragraph">
                The
                <router-link to="/info#prices">prices</router-link> are in
                Swedish krona (SEK) and exclusive of V.A.T
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="pl-xl-5">
              <h2>TICKETS</h2>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="pl-xl-5">
              <div v-for="ticket in tickets" :key="ticket.index" class="ticket">
                <div>
                  <b-row>
                    <b-col cols="8">
                      <p class="name">{{ ticket.name }}</p>
                      <p class="info" v-if="ticket.description">
                        {{ ticket.description }}
                      </p>
                      <p class="info">
                        {{ ticket.type }} | Ticket price: {{ ticket.price }} SEK
                      </p>
                    </b-col>
                    <b-col cols="4" class="pr-xl-5">
                      <a
                        v-if="!ticket.soldout"
                        :href="ticket.link"
                        target="_blank"
                        rel="noopener noreferrer"
                        role="button"
                        class="btn btn-lime-green float-right buy-button-padding"
                      >
                        Buy
                      </a>
                      <!-- hidden sold out button-->
                      <button
                        v-else
                        class="btn btn-lime-green float-right sold-out-button-padding"
                        disabled
                      >
                        Sold&nbsp;Out
                      </button>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="pl-xl-5">
              <p>
                <router-link to="/info#cancellation">
                  Cancellation policy</router-link
                >
              </p>
            </b-col>
          </b-row>
        </b-container>

        <b-container fluid class="bg-beige py-4">
          <b-row align-v="center">
            <b-col cols="12" md="8" class="pl-xl-5">
              <h3>Save 10-15%</h3>
              <p class="m-0">
                Book your tickets together with your colleagues! There are great
                offers available on Regular tickets for groups of 10 people or
                more
              </p>
            </b-col>
            <b-col cols="12" md="4" class="text-md-right pr-xl-5">
              <p>
                <a href="mailto:info@oredev.org">Contact Us</a>
              </p>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "TopTicketsSection",
  data() {
    return {
      tickets: [
        {
          name: "3-Days Conference Pass",
          type: "Early Bird",
          price: "12 000",
          link: "https://www.trippus.net/oredev2025/EarlyBird",
          soldout: false,
        },
        {
          name: "3-Days Conference Pass + Hotel",
          type: "Early Bird",
          price: "16 260",
          link: "https://www.trippus.net/oredev2025/EarlyBird",
          soldout: false,
        },
        {
          name: "3-Days Conference Pass",
          type: "Blind Bird",
          price: "10 000",
          link: "https://www.trippus.net/oredev2025/BlindBird",
          soldout: true,
        },
        {
          name: "3-Days Conference Pass + Hotel",
          type: "Blind Bird",
          price: "14 260",
          link: "https://www.trippus.net/oredev2025/BlindBird",
          soldout: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@use "@/styles/variables.scss" as *;
h1 {
  font-size: 18px;
  @media (min-width: 577px) and (max-width: 1500px) {
    font-size: 24px;
  }
  @media (min-width: 1501px) {
    font-size: 32px;
  }
}
h3 {
  font-size: 18px;
  @media (min-width: 577px) {
    font-size: 24px;
  }
}

.background {
  background-color: $dark-brown;
  margin-top: -2px;
  @media (min-width: 992px) {
    background-repeat: no-repeat;
    background-position: right top;
    background-image: url("https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Tickets_page/tickets.png");
    height: 987px;
    background-size: auto 100%;
    overflow: hidden;
    .bouncing-eye {
      width: 209px;
      right: 164px;
      top: 329px;
    }
    .twirl {
      width: 200px;
      right: 622px;
      top: -6px;
    }
  }
  @media (min-width: 1900px) {
    background-size: 100% auto;
    padding-bottom: 52%;
    width: 100%;
    .bouncing-eye {
      width: 11vw;
      right: 9vw;
      top: 17vw;
    }
    .twirl {
      width: 10vw;
      right: 35vw;
      top: 1vw;
    }
  }
}

.prices-info-paragraph {
  letter-spacing: 0%;
  font-size: 12px;
  @media (min-width: 1400px) {
    font-size: 14px;
  }
}

.ticket {
  p {
    letter-spacing: 0;
  }
  .name {
    font-weight: 400;
    margin-bottom: 0;
    font-size: 14px;
    @media (min-width: 500px) {
      font-size: 18px;
    }
  }
  .info {
    font-size: 13px;
    @media (min-width: 450px) {
      font-size: 14px;
    }
  }
  .buy-button-padding {
    padding-left: 34px;
    padding-right: 34px;
    @media (min-width: 577px) {
      padding-left: 60px;
      padding-right: 60px;
    }
    @media (min-width: 992px) {
      padding-left: 34px;
      padding-right: 34px;
    }
    @media (min-width: 1500px) {
      padding-left: 60px;
      padding-right: 60px;
    }
  }
  .sold-out-button-padding {
    padding-left: 10px;
    padding-right: 10px;
    @media (min-width: 577px) {
      padding-left: 36px;
      padding-right: 36px;
    }
    @media (min-width: 992px) {
      padding-left: 10px;
      padding-right: 10px;
    }
    @media (min-width: 1500px) {
      padding-left: 36px;
      padding-right: 36px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/TicketsPage/TopTicketsSection.vue